import { EXPLORER_FILTER_PAGE_SIZE_KEY } from "../../../utils/constants";
import {
    UPDATE_EXPLORER_CURRENT_FOLDER,
    UPDATE_EXPLORER_FILES,
    UPDATE_EXPLORER_FILTER,
    UPDATE_EXPLORER_FOLDERS,
    UPDATE_EXPLORER_SELECTED_FILE,
    UPDATE_EXPLORER_SELECTED_FILES,
    UPDATE_FILTERED_FILES,
    CLOSE_SIGN_INPUT_MODAL,
    RESET_CLOSE_SIGN_INPUT_MODAL,
    UPDATE_SIGN_PROCESSING,
    UPDATE_COMPLETED_SIGN_CNT,
} from "../actionTypes";
import { updateState } from "../utils";

const initialState = {
    folders: null,
    currentFolder: null,
    filter: {
        page: 1,
        pageSize: Number(localStorage.getItem(EXPLORER_FILTER_PAGE_SIZE_KEY) || 10),
        searchKey: null,
        startDate: null,
        endDate: null,
        documentStatus: "",
        sortKey: "created_at",
        sortDirection: "desc",
    },
    files: null,
    total: 0,
    selectedFiles: [],
    filteredFiles: [],
    closeSignInputModal: false,
    signProcessing: false,
    completedSignCnt: 0,
};

const updateFolders = (state, action) => {
    return updateState(state, {
        folders: action.folders,
    });
};

const updateCurrentFolder = (state, action) => {
    return updateState(state, {
        currentFolder: action.currentFolder,
    });
};

const updateFilter = (state, action) => {
    return updateState(state, {
        filter: action.filter,
    });
};

const updateFiles = (state, action) => {
    return updateState(state, {
        files: action.files,
        total: action.total,
    });
};

const updateSelectedFile = (state, action) => {
    return updateState(state, {
        selectedFile: action.selectedFile,
    });
};

const updateSelectedFiles = (state, action) => {
    return updateState(state, {
        selectedFiles: action.selectedFiles,
    });
};

const updateFilteredFiles = (state, action) => {
    return updateState(state, {
        filteredFiles: action.filteredFiles,
    })
}

const closeSignInputModal = (state) => {
    return updateState(state, {
        closeSignInputModal: true,
    });
}

const resetCloseSignInputModal = (state) => {
    return updateState(state, {
        closeSignInputModal: false,
    });
}

const updateSignProcessing = (state, action) => {
    return updateState(state, {
        signProcessing: action.signProcessing,
    });
}

const updateCompletedSignCnt = (state, action) => {
    return updateState(state, {
        completedSignCnt: action.completedSignCnt
    })
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_EXPLORER_FOLDERS:
            return updateFolders(state, action);
        case UPDATE_EXPLORER_CURRENT_FOLDER:
            return updateCurrentFolder(state, action);
        case UPDATE_EXPLORER_FILTER:
            return updateFilter(state, action);
        case UPDATE_EXPLORER_FILES:
            return updateFiles(state, action);
        case UPDATE_EXPLORER_SELECTED_FILE:
            return updateSelectedFile(state, action);
        case UPDATE_EXPLORER_SELECTED_FILES:
            return updateSelectedFiles(state, action);
        case UPDATE_FILTERED_FILES:
            return updateFilteredFiles(state, action);
        case CLOSE_SIGN_INPUT_MODAL:
            return closeSignInputModal(state, action);
        case RESET_CLOSE_SIGN_INPUT_MODAL:
            return resetCloseSignInputModal(state, action);
        case UPDATE_SIGN_PROCESSING:
            return updateSignProcessing(state, action);
        case UPDATE_COMPLETED_SIGN_CNT:
            return updateCompletedSignCnt(state, action);
        default:
            return state;
    }
};

export default reducer;
